import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { LeadProvider } from "@/context/LeadContext";
import { BookingProvider } from "@/context/BookingContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Realisations from "@/pages/Realisations";
import Urgence from "@/pages/Urgence";
import Devis from "@/pages/Devis";
import NotFound from "@/pages/NotFound";
import SlugRouter from "@/pages/SlugRouter";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <LeadProvider>
          <BookingProvider>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/realisations" element={<Realisations />} />
                <Route path="/intervention-urgence" element={<Urgence />} />
                <Route path="/devis" element={<Devis />} />
                <Route path="/404" element={<NotFound />} />
                <Route path="/:slug" element={<SlugRouter />} />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
            <Toaster position="top-center" richColors />
          </BookingProvider>
        </LeadProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
